import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// "Channing & Presley Welch" when siblings share a last name, else "Arabella Cano & Melody Kimbro".
export function familyLabel(names) {
  const list = [...new Set((names || []).map((n) => (n || "").replace(/\s+/g, " ").trim()).filter(Boolean))]
    .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
  if (list.length <= 1) return list[0] || "";
  const join = (arr) => (arr.length === 1 ? arr[0] : `${arr.slice(0, -1).join(", ")} & ${arr[arr.length - 1]}`);
  const parts = list.map((n) => { const i = n.lastIndexOf(" "); return i > 0 ? [n.slice(0, i), n.slice(i + 1)] : [n]; });
  const lasts = new Set(parts.map((p) => (p[1] || "").toLowerCase()));
  if (parts.every((p) => p.length === 2) && lasts.size === 1) return `${join(parts.map((p) => p[0]))} ${parts[0][1]}`;
  return join(list);
}
